export default __webpack_public_path__ + "static/media/ASTExp.df3b37e4.md";